import { generateActions, generateSelectors, generateTypes } from "../util";

export const key = "user";

// fetch user
export const FETCH_USER = generateTypes(key, "current");
export const [fetchUser, fetchUserSuccess, fetchUserError, fetchUserBusy, fetchUserPoll] = generateActions(FETCH_USER);
export const [selectUser, selectUserError, selectUserBusy, selectUserPoll, selectUserRequest] =
  generateSelectors(FETCH_USER);

// update user
export const UPDATE_USER = generateTypes(key, "update");
export const [updateUser, updateUserSuccess, updateUserError, updateUserBusy] = generateActions(UPDATE_USER);
export const [selectUpdateUser, selectUpdateUserError, selectUpdateUserBusy, , selectUpdateUserRequest] =
  generateSelectors(UPDATE_USER);

// login user
export const LOGIN_USER = generateTypes(key, "login");
export const [loginUser, loginUserSuccess, loginUserError, loginUserBusy] = generateActions(LOGIN_USER);
export const [selectLoginUser, selectLoginUserError, selectLoginUserBusy, , selectLoginUserRequest] =
  generateSelectors(LOGIN_USER);

// logout user
export const LOGOUT_USER = generateTypes(key, "logout");
export const [logoutUser, logoutUserSuccess, logoutUserError, logoutUserBusy] = generateActions(LOGOUT_USER);
export const [selectLogoutUser, selectLogoutUserError, selectLogoutUserBusy, , selectLogoutUserRequest] =
  generateSelectors(LOGOUT_USER);

// reset user
export const RESET_USER = generateTypes(key, "reset-user");
export const [resetUser, resetUserSuccess, resetUserError, resetUserBusy] = generateActions(RESET_USER);
export const [selectResetUser, selectResetUserError, selectResetUserBusy, , selectResetUserRequest] =
  generateSelectors(RESET_USER);

//verify code
export const VERIFY_CODE = generateTypes(key, "verify-code");
export const [verifyCode, verifyCodeSuccess, verifyCodeError, verifyCodeBusy] = generateActions(VERIFY_CODE);
export const [selectVerifyCode, selectVerifyCodeError, selectVerifyCodeBusy, , selectVerifyCodeRequest] =
  generateSelectors(VERIFY_CODE);
